module.exports = __webpack_public_path__ + "img/v.830ed93f.png";